import { useState, useEffect } from 'react';

// Module-level cache — shared across all component instances on the same page load.
// Reduces 6 identical fetch('/content/home/home.json') calls down to 1.
let cachedData = null;
let pendingPromise = null;

export function useHomeData() {
  const [data, setData] = useState(cachedData);

  useEffect(() => {
    let mounted = true;

    if (cachedData) {
      setData(cachedData);
      return;
    }

    if (!pendingPromise) {
      pendingPromise = fetch('/content/home/home.json')
        .then(res => res.json())
        .then(json => {
          cachedData = json;
          return json;
        })
        .catch(err => {
          pendingPromise = null;
          console.error('Error fetching home data:', err);
          throw err;
        });
    }

    pendingPromise
      .then(json => { if (mounted) setData(json); })
      .catch(() => {});

    return () => { mounted = false; };
  }, []);

  return { data };
}
